import SigliveServiceV2 from 'Service/sigliveServiceV2';

const getSchedules = async ({ queries }) => {
  const { data } = await SigliveServiceV2({
    method: 'GET',
    url: `/schedule/list?${queries}`,
  });

  return data?.data;
};

export default getSchedules;
